<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">积分充值</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
    <!-- 充值顶部  开始 -->
    <div class="page_topmine">
      <div class="account_top">
        <div class="account_jifen">
          <div class="account_jifennum">{{amount}}</div>
          <div class="account_jifentext">账户积分</div>
        </div>
        <div class="account_kaquanList" @click="tocouponsList()">卡券列表</div>
      </div>
    </div>
    <!-- 充值顶部  结束 -->
    <!-- 充值详情  开始 -->
    <div class="page_taocan account_taocan">
      <div class="page_tab account_detailtop">
        <div class="page_tablist account_detailbox" v-for="(item,index) in tabHead" @click="changetabHead(index)">
          <div :class="item.isselect? 'page_tabname' : 'page_tabname1'" class="account_detail_name">{{item.name}}</div>
        </div>
      </div>
      <div class="account_input" v-if="selectIndex===0">
        <input class="account_detail_input" :value="phoneNum" disabled />
        <div class="account-codebox" v-if="userinfo.bind_partner == 12">
          <input class="account-code-input" type="number" placeholder="请输入验证码" v-model="phoneCode" />
          <div class="account-phonebotton" @click="getPhoneCode()">
            {{ currentTime ? currentTime : "获取验证码" }}
          </div>
        </div>
      </div>
      <div class="account_inputchong" v-if="selectIndex===1">
        <input class="account_detail_chonginput" placeholder="请输入卡号" v-model="couponNum" />
        <input class="account_detail_chonginput" placeholder="请输入兑换码" v-model="couponCode" />
        <div class="scancode" @click="scanCode()">
          <img class="scancode-img" src="/static/saoma.png" />
          <div class="scancode-text">扫码识别</div>
        </div>
        <div class="scancode-tip">如遇识别错误，可试多次</div>
      </div>
    </div>
    <!-- 充值详情  结束 -->
    <!-- 支付 开始 -->
    <div class="page_button account_lingqu" @click="recharge()">
      <div class="page_zhifu">{{selectIndex===1? '充值' : '领取'}}</div>
    </div>
    <!-- 支付 结束 -->
    <!-- 注意事项  开始 -->
    <div class="page_mesg">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">充值说明</div>
      </div>
      <div class="page_mesgtip">1.积分可用于购买平台内所有服务</div>
     <!-- <div class="page_mesgtip">2.积分可提现</div> -->
<!--      <div class="page_mesgtip">2.如存在无法充值，充值失败等问题，可联系客服<a :href="'tel:' + telNumber">{{telNumber}}</a></div>-->
    </div>
    <!-- 注意事项  结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import httpers from '../../api/https';
  import {
    Dialog
  } from 'vant';
  // import Vconsole from 'vconsole';
  // var vConsole = new VConsole();
  export default {
    data() {
      return {
        tabs: [{
          value: "充值",
          isActive: true
        }, {
          value: "提现",
          isActive: false
        }],
        tabsindex: 0, //tabs的index默认为0
        tabHead: [{
            name: "手机领",
            isselect: true
          },
          {
            name: "卡券充",
            isselect: false
          }
        ],
        buttonClicked: false, // 防止支付重复点击,默认为false
        amount: '', // 接口获取余额
        coupon: '', // 接口获取卡券
        couponNum: '', // 卡券充-充值兑换号码,默认为空
        couponCode: '', // 卡券充-充值兑换密码,默认为空
        phoneNum: '', // 手机领-手机号码,默认为空
        sureList: [], //接口领取通用卡前确认列表数据
        chongzhiisselect: true,
        selectIndex: 0,
        checknum: "", //选择的积分
        shownum: false, //是否选择积分
        timoney: '', //提现的金额
        daomoney: '', //到账的金额
        showDialog: false, //weui的数据
        showTopTips: [{
            text: '输入不能有空!',
            checked: false
          },
          {
            text: '当前账号没有可领取的卡券!',
            checked: false
          },
          {
            text: '验证码输入有误!',
            checked: false
          },
          {
            text: '请输入您的手机号码!',
            checked: false
          },
          {
            text: '请输入正确的兑换密码!',
            checked: false
          },
          {
            text: '请输选择提现账户!',
            checked: false
          },
          {
            text: '提现积分不能大于可用积分!',
            checked: false
          },
          {
            text: '提现积分要大于或等于100!',
            checked: false
          },
          {
            text: '提现积分要小于等于2000!',
            checked: false
          }
        ], // 错误提示列表
        isPhone: true, // 用户点击选中卡券充，否则手机领。默认为false
        // phoneNumber: config.phoneNumber, // 服务热线、客服电话
        oilzhangItem: {}, //从上一页面传过来的银行卡提现账户
        alipayitem: {}, //从上一页面传过来的支付宝账号
        cardNo: "", //提现账户号码
        id: "", //提现账户id
        type: "", //提现账户类型
        istimoney: true, //提现的金额是否大于余额
        withdraw_fail_limit: "",
        withdraw_money_limit: "",
        withdraw_radio: "",
        failnum: 0,
        telNumber: "" ,//客服电话
        canWithdraw:true,
        userinfo: {}, //用户信息
        phoneCode: '', // 验证码,默认为空
        currentCode: '', // 接口获取正确的验证码,默认为空
        currentTime: '', // 验证码倒计时,默认为空
        phoneCodeStatus: false, // 验证码状态,默认为false
      }
    },
    created() {
      this.getwechat({
        url: location.href.split('#')[0]
      })
      this.request('getUserInfo')
      this.request("getWithdrawParams")
      console.log("客服电话", sessionStorage.getItem("phoneNumber"))
      this.telNumber = sessionStorage.getItem("phoneNumber")
      let that = this
      //首页传来的参数
      if (that.$route.params.tabs) {
        that.tabsindex = that.$route.params.tabs
      }
      //账户列表传来的参数
      if (that.$route.params.carditem) {
        that.cardNo = that.$route.params.carditem.cardNo
        that.id = that.$route.params.carditem.id
        that.oilzhangItem = that.$route.params.carditem
        console.log('oilzhangItem', that.oilzhangItem)
      }
    },
    mounted() {

    },
    methods: {
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      //获取微信配置信息接口
      getwechat(requestData = {}) {
        console.log('getwechat 1')
        httper.get("wechat/wechat/sign-package", requestData, res => {
          console.log(res);
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          });
        })
      },
      scanCode() {
        let that = this
        wx.ready(() => {
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            onlyFromCamera: true,
            scanType: ["barCode"],
            success: function(res) {
              console.log(res)
              if (res) {
                let result = (res.resultStr).split(",")
                that.couponCode = result[1]
                console.log('that.codePassword',that.couponCode)
              }
              // var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
              // window.location.href = result; //因为我这边是扫描后有个链接，然后跳转到该页面
            }
          });
        });
      },
      //返回上一页
      toReturn() {
        this.$router.go(-1)
      },
      //充值还是领取
      changeTab(tabindex) {
        console.log('tabindex:', tabindex)
        let tabs = [{
          value: "充值",
          isActive: true
        }, {
          value: "提现",
          isActive: false
        }]
        tabs.forEach((v, i) => i === tabindex ? v.isActive = true : v.isActive = false)
        this.tabs = tabs
        this.tabsindex = tabindex
      },
      //改变充值还是手机领券
      changetabHead(e) {
        let that = this
        let tabHead = that.tabHead
        tabHead.map((item, index) => item.isselect = index === Number(e))
        that.chongzhiisselect = that.tabHead[Number(e)].isselect
        console.log("that.chongzhiisselect", that.chongzhiisselect)
        that.selectIndex = Number(e)
        console.log("that.selectIndex", that.selectIndex)
        if (Number(e) === 1) {
          this.isPhone = false
        } else {
          this.isPhone = true
        }
      },
      //跳转卡券列表
      tocouponsList() {
        this.$router.push({
          path: '/couponsList'
        })
      },
      //获取验证码
      getPhoneCode() {
        let that = this
        let requestData = {}
        // 获取验证码
        that.buttonClickedFun(1500)
        requestData.mobile = that.phoneNum
        this.request('sendCode', requestData)

      },
      //所选套餐(已弃用)
      selectnum(e) {
        let that = this
        let numList = that.numList
        numList.map((item, index) => item.select = index === Number(e))
        that.checknum = that.numList[Number(e)].num1
        that.shownum = true
      },
      //跳转充值卡充值界面(已弃用)
      toRechargeCard() {
        this.$router.push({
          path: '/rechargeCard'
        })
      },
      //跳转充值记录(已弃用)
      toRecord() {
        this.$router.push({
          path: '/record'
        })
      },
      //充值或领取
      recharge() {
        let that = this
        // let showTopTips = this.showTopTips

        if (!this.isPhone) {
          console.log('卡券充,兑换号码：', this.couponNum, '卡券充,兑换密码：', this.couponCode)
          // 兑换码格式错误时顶部显示错误提示2秒(验证待施工
          if (!this.couponNum || !this.couponCode) {
            //this.$swal('错误!', '兑换码格式错误')
            this.$toast({
              message: '兑换码格式错误',
            });
            return
          }
          //调用接口领取通用卡前确认列表数据
          let requestData = {
            type: 'password',
            card_no: this.couponNum,
            hash_password: this.couponCode
          }
          this.request('bindsureList', requestData)
          return
        } else {
          if (this.userinfo.bind_partner == 12) {
            if (!that.phoneCode || that.phoneCode != that.currentCode) {
              this.$toast({
                message: '请输入正确的验证码'
              })
              return
            }
          }
          if (that.phoneNum) {
            let requestData = {
              type: 'mobile',
              mobile: that.phoneNum
            }
            this.request('bindsureList', requestData)
          } else {}


        }
      },
      //提现选择账户
      getzhang() {
        this.$router.push({
          path: '/zhanghuList'
        })
      },

      jiInput(e) {
        let that = this
        let showTopTips = this.showTopTips
        let timoney = that.timoney.replace(/\s*/g, '')
        console.log('总积分', parseInt(that.amount))
        console.log("提现积分", parseInt(timoney))
        that.timoney = timoney
        let daomoney = (Number(that.timoney) * that.withdraw_radio).toFixed(2)
        that.daomoney = daomoney
        console.log('daomoney', that.daomoney)

      },
      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code === 0) {
                let userinfo = res.data
                console.log('userinfo', userinfo)
                that.userinfo = res.data
                if (userinfo.mobile) {
                  that.phoneNum = userinfo.mobile
                } else {
                  Dialog.confirm({
                      title: '提示',
                      message: '请先绑定手机',
                    })
                    .then(() => {
                      that.$router.push({
                        path: "/changePhoneNum"
                      })
                    })
                    .catch(() => {
                      return false;
                    });
                }
                // sessionStorage.setItem('userinfo', JSON.stringify(userinfo))
                // that.phoneNum = userinfo.mobile ? userinfo.mobile : 'meiyou'
                that.amount = userinfo.account.amount
                if(userinfo.can_withdraw==0){
                  that.canWithdraw = false
                }
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            // 发送短息验证码
            case 'sendCode':
              httpers.post('msg/send-code', requestData, res => {
                console.log('code：', res.data)
                if (res.code == 0) {
                  that.currentCode = res.data
                  this.$toast({
                    message: '验证码已发送',
                  });
                  // 倒计时
                  let time = 91
                  let interval = setInterval(() => {
                    time--
                    if (time > 10) {
                      that.currentTime = time + '秒'
                    }
                    if (time > 0 && time <= 10) {
                      that.currentTime = ' ' + time + '秒'
                    }
                    if (time <= 0) {
                            clearInterval(interval)
                            that.currentTime = ''
                          }
                        }, 1000)
                      }
                    })
                    break
            //获取券的列表
          case 'bindsureList':
            httper.post('card/receive-before', requestData, res => {
              if (res.code === 0) {
                let resultData = res.data
                console.log("resultData：", resultData)
                this.sureList = res.data
                this.istrue = true
                let resultDatalist = ''
                if (this.isPhone) {
                  if (that.phoneNum) {
                    this.$router.push({
                      path: '/cardList',
                      query: {
                        phoneNum: that.phoneNum,
                        canWithdraw:that.canWithdraw
                      }
                    })
                  }
                } else {
                  if (resultData.length > 1) {
                    for (let i = 0; i < resultData.length; i++) {
                      if (resultDatalist) {
                        resultDatalist = resultDatalist + "\n" + resultData[i].name
                      } else {
                        resultDatalist = resultData[i].name
                      }
                    }
                  } else {
                    resultDatalist = resultData[0].name
                  }
                  Dialog.confirm({
                      message: resultDatalist,
                      cancelButtonText: "取消",
                      confirmButtonText: "充值"
                    })
                    .then(() => {
                      if (!that.isPhone) {
                        let requestData = {
                          type: 'password',
                          card_no: that.couponNum,
                          hash_password: that.couponCode
                        }
                        that.request('bindCoupon', requestData)
                      } else {
                        let requestData = {
                          type: 'mobile',
                          mobile: that.phoneNum
                        }
                        that.request('bindCoupon', requestData)
                      }
                    })
                    .catch(() => {
                      return false;
                    });
                }
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
            //充值的
          case 'bindCoupon':
            httper.post('card/receive', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '充值成功'
                })
                setTimeout(() => {
                  // window.location.reload()
                  this.$router.push({
                    path:"/jifenmingxi"
                  })
                }, 3000)
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style scoped>
  .account_top {
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
  }

  .account_jifen {}

  .account_jifennum {
    font-size: 26px;
  }

  .account_jifentext {
    font-size: 13px;
    font-weight: 400;
    color: rgba(247, 247, 247, 1);
  }

  .account_kaquanList {
    width: 61px;
    height: 23px;
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 11px;
    font-size: 9px;
    color: rgba(247, 247, 247, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .account_taocan {
    /* top: 133px; */
    /* height: 230px; */
    /* height: 265px; */
     height: 285px;
    padding: 0;
    width: 90%;
  }

  .page_tab {
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .page_tablist {
    height: 100%;
    position: relative;
  }

  .page_tabname {
    height: 100%;
    display: flex;
    font-size: 13px;
    align-items: center;
  }

  .page_tabname::after {
    content: "";
    top: auto;
    bottom: 0;
    width: 40%;
    position: absolute;
    left: 25%;
    height: 3px;
    background-color: #FD8C00;
  }

  .page_tabname1 {
    height: 100%;
    font-size: 13px;
    display: flex;
    align-items: center;
  }

  .account_detailtop {
    height: 45px;
    border-bottom: 1px solid #dedede;
  }

  .account_detailbox {}

  .account_detail_name {}

  .account_input {
    display: flex;
    justify-content: center;
    align-items: center;
   /* height: 103px; */
    width: 100%;
    padding: 20px 0;
    box-sizing: border-box;
    flex-direction: column;
  }

  .account_inputchong {
    display: flex;
    align-items: center;
    /* height: 183px; */
     height: 220px;
    flex-direction: column;
  }

  .account_detail_input {
    width: 248px;
    height: 46px;
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 7px;
    padding: 0 10px;
    box-sizing: border-box;
    background-color: #fff;
  }

  .account_detail_chonginput {
    width: 248px;
    height: 46px;
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 7px;
    padding: 0 10px;
    background-color: #fff;
    margin-top: 20px;
  }

  .account_lingqu {
    /* margin-top: 172px; */
   /* margin-top: 195px; */
   /* margin-top: 220px; */
  }

  ::-webkit-input-placeholder {
    text-align: start;
    color: rgba(187, 187, 187, 1);
    font-size: 14px;
    background-color: rgba(0,0,0,0);
  }

  .scancode {
    width: 269px;
    height: 46px;
    background: #FD8C00;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    margin-top: 20px;
  }

  .scancode-img {
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }

  .scancode-text {
    font-size: 14px;
  }
  .scancode-tip{
    font-size: 14px;
    color: #FD8C00;
    text-align: center;
    margin-top: 10px;
  }
  .account-codebox {
    width: 248px;
    height: 46px;
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 7px;
    padding: 0 10px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .account-code-input {
    width: calc(100% - 80px);
    height: 100%;
    border: none;
  }

  .account-phonebotton {
    /* width: 80px;
    height: 40px; */
    padding-left: 8px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    font-size: 14px;
    border-left: 1px solid rgba(210, 210, 210, 1);
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/account.vue